import AuthService from './AuthService';

import apiService from '../ApiService';

export default new AuthService(apiService);
